import { FormattedMessage } from 'react-intl';
import {
  FIELD_MEMBERS,
  FIELD_SET_COMMON_PAY_FREQUENCY,
  FIELD_TEXT_REQUIRED,
  WAGES_AND_INCOME_COMMON_FIELD_NAMES,
} from './constants.fields';
import { getDisabledMembers } from 'pages/AffordaWagesAndIncome/utils';

export const MAX_RECORDS_BY_USER = 5;

export const NEW_RECORD = {
  memberId: '',
  source: '',
  payFrequency: '',
  weeklyAmount: '',
  monthlyAmount: '',
  annualAmount: '',
};

export const MESSAGE_IDS = {
  title: 'afforda.wagesAndIncome.details.other.title',
  description: 'afforda.wagesAndIncome.details.other.subtitle',
  addButton: 'afforda.wagesAndIncome.details.other.add',
  addCaption: 'afforda.wagesAndIncome.details.other.addDescription',
};

export const OTHER_INCOME_FIELD_NAMES = {
  id: 'id',
  memberId: WAGES_AND_INCOME_COMMON_FIELD_NAMES.memberId,
  source: WAGES_AND_INCOME_COMMON_FIELD_NAMES.source,
  payFrequency: WAGES_AND_INCOME_COMMON_FIELD_NAMES.payFrequency,
  weeklyAmount: WAGES_AND_INCOME_COMMON_FIELD_NAMES.weeklyAmount,
  monthlyAmount: WAGES_AND_INCOME_COMMON_FIELD_NAMES.monthlyAmount,
  annualAmount: WAGES_AND_INCOME_COMMON_FIELD_NAMES.annualAmount,
};

export const getDefaultValues = (item) => {
  return {
    ...item,
    [OTHER_INCOME_FIELD_NAMES.id]: item.id,
    [OTHER_INCOME_FIELD_NAMES.source]: item.source ?? '',
    [OTHER_INCOME_FIELD_NAMES.payFrequency]: item.payFrequency ?? '',
    [OTHER_INCOME_FIELD_NAMES.weeklyAmount]: item.weeklyAmount ?? '',
    [OTHER_INCOME_FIELD_NAMES.monthlyAmount]: item.monthlyAmount ?? '',
    [OTHER_INCOME_FIELD_NAMES.annualAmount]: item.annualAmount ?? '',
  };
};

export const getFormProps = ({ items, memberId }) => {
  return {
    disabledMembers: getDisabledMembers(items, memberId, MAX_RECORDS_BY_USER),
  };
};

export const FIELDS = ({ intl, members, disabledMembers }) => {
  return [
    ...FIELD_MEMBERS({ members, disabledMembers }),
    // Source
    {
      ...FIELD_TEXT_REQUIRED,
      label: (
        <FormattedMessage id="afforda.wagesAndIncome.details.other.source" />
      ),
      placeholder: intl.formatMessage({
        id: 'afforda.wagesAndIncome.details.other.source',
      }),
      name: OTHER_INCOME_FIELD_NAMES.source,
      watchFields: [OTHER_INCOME_FIELD_NAMES.memberId],
      hidden: ({ getValues }) =>
        !getValues(OTHER_INCOME_FIELD_NAMES.memberId)?.length,
    },

    // Pay Frequency
    ...FIELD_SET_COMMON_PAY_FREQUENCY,
  ];
};
